import { render, staticRenderFns } from "./simOpenWup.vue?vue&type=template&id=8c3bc74e&scoped=true&"
import script from "./simOpenWup.vue?vue&type=script&lang=js&"
export * from "./simOpenWup.vue?vue&type=script&lang=js&"
import style0 from "./simOpenWup.vue?vue&type=style&index=0&id=8c3bc74e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3bc74e",
  null
  
)

export default component.exports